module.exports = __webpack_public_path__ + "img/champin.21fba7da.png";